import { Navigate, Route, Routes } from 'react-router-dom'

import { Home } from './Home'
import { StickerProvider } from '../shared/sticker/StickerProvider'
import { DndContextWithSensor } from '../shared/dnd'
import { Schedule } from './Schedule'
import { Travel } from './Travel'
import { Attire } from './Attire'
import { Guide } from './Guide'
import { March2019 } from './March2019'
import { September2025 } from './September2025'
import { StickerWall } from './StickerWall'
import { Registry } from './Registry'

export function Content() {
  return (
    <StickerProvider>
      <DndContextWithSensor>
        <ContentRouter />
      </DndContextWithSensor>
    </StickerProvider>
  )
}

function ContentRouter() {
  return (
    <Routes>
      <Route path={`/home`} element={<Home />} />
      <Route path={`/schedule`} element={<Schedule />} />
      <Route path={`/travel`} element={<Travel />} />
      <Route path={`/attire`} element={<Attire />} />
      <Route path={`/guide`} element={<Guide />} />
      <Route path={`/2019`} element={<March2019 />} />
      <Route path={`/2025`} element={<September2025 />} />
      <Route path={`/registry`} element={<Registry />} />
      <Route path={`/stickers`} element={<StickerWall />} />
      <Route path={`/`} element={<Navigate to="/home/" />} />
    </Routes>
  )
}
